/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ScrollerList from '@/components/ScrollerList';
import OrderItem from '@/components/ScrollerList/OrderItem';
import { sysRoleType } from '@/constant';
import { mapGetters, mapState } from 'vuex';
export default {
  components: {
    ScrollerList: ScrollerList,
    OrderItem: OrderItem
  },
  props: {
    height: {
      type: Number,
      required: true
    },
    data: {
      type: [Array, String],
      default: function _default() {
        return [];
      }
    },
    isPx: {
      type: Boolean,
      default: true
    },
    isCard: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      sysRoleType: sysRoleType
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), mapGetters('global', ['getStateName'])),
  methods: {
    spliteHyperLink: function spliteHyperLink() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      url = url || '';
      var index = url.indexOf(',') > 0 ? url.indexOf(',') : 0;
      return [url.slice(0, index), url.slice(index + 1)];
    },
    formatFieldList: function formatFieldList(field) {
      return "".concat(field.name, "\uFF1A").concat(field.value === '' || field.value === null ? '-' : field.value);
    },
    enablePullup: function enablePullup() {
      this.$refs['orderList'].enablePullup();
    },
    disablePullup: function disablePullup() {
      this.$refs['orderList'].disablePullup();
    },
    donePulldown: function donePulldown() {
      this.$refs['orderList'].donePulldown();
    },
    donePullup: function donePullup() {
      this.$refs['orderList'].donePullup();
    },
    scrollToTop: function scrollToTop() {
      this.$refs['orderList'].scrollToTop();
    },
    // 隐藏客户信息
    hideInfo: function hideInfo() {
      var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var frontLen = arguments.length > 1 ? arguments[1] : undefined;
      var endLen = arguments.length > 2 ? arguments[2] : undefined;
      var len = str.length - frontLen - endLen;
      var xing = '';

      for (var i = 0; i < len; i++) {
        xing += '*';
      }

      return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
    },
    // 客户名称
    customName: function customName(item) {
      if (item.placeState === 1) {
        if (this.$oauth('01025')) {
          return item.customName + (item.order_sponsor_type === 2 && item.take_order_user_position ? item.take_order_user_position : '');
        } else {
          var name = item.customName + (item.order_sponsor_type === 2 && item.take_order_user_position ? item.take_order_user_position : '');
          return this.hideInfo(name, 1, 0);
        }
      } else {
        return item.customName + (item.order_sponsor_type === 2 && item.take_order_user_position ? item.take_order_user_position : '');
      }
    },
    // 服务地址
    serviceAddess: function serviceAddess(item) {
      var address = (item.gps_addr || '') + (item.custom_detail_addr || '');

      if (item.placeState === 1) {
        if (this.$oauth('01025')) {
          return address;
        } else {
          return this.hideInfo(address, 0, 0);
        }
      } else {
        return address;
      }
    },
    customLinkPerson: function customLinkPerson(orderInfo) {
      if (orderInfo.placeState === 1) {
        if (this.$oauth('01025')) {
          return orderInfo.customLinkPerson;
        } else {
          var len = orderInfo.customLinkPerson;
          return this.hideInfo(len, 1, 0);
        }
      } else {
        return orderInfo.customLinkPerson;
      }
    },
    // 客户手机号
    customPhone: function customPhone(orderInfo) {
      if (orderInfo.placeState === 1) {
        if (this.$oauth('01025')) {
          return orderInfo.phone;
        } else {
          var phone = orderInfo.phone;
          return this.validatePhone(phone);
        }
      } else {
        return orderInfo.phone;
      }
    },
    validatePhone: function validatePhone() {
      var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      var number = '';

      if (myreg.test(phone)) {
        number = this.hideInfo(phone, 3, 4);
      } else if (phone.length > 4) {
        number = this.hideInfo(phone, 0, 4);
      } else if (phone.length < 4) {
        number = this.hideInfo(phone, 1, 0);
      }

      return number;
    }
  }
};